module.exports = __webpack_public_path__ + "static/media/fuad.2175aceb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/Team/fuad.jpg
// module id = 170
// module chunks = 0